import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import _keyBy from 'lodash/keyBy';

import { FEATURE_FLAGS } from 'constants/apis';
import { useApp } from 'providers/AppProvider';
import axios from 'helpers/axios';

// 1 hour.
const STALE_TIME = 60 * 60 * 1000;

const useFeatureFlags = () => {
  const { id } = useApp();
  const jwt = localStorage.getItem('global-opportunities-jwt');

  // Edge case when there is no JWT available that it can still try to
  // make an authenticated request which results in weird redirect behaviour
  // due to the nature of our routing setup in `App.jsx` and how we cache
  // account details in local storage, etc.
  // E.g. Sign in as a pre-registered vendor who has no active PV subscription. You
  // would previously get redirected to `/subscribe` then back to `/login`
  // since this results in a `403` error.
  const cleanUserId = jwt && id ? id : 'USER_ANON';

  const {
    isLoading,
    isError,
    data: { data } = {},
  } = useQuery(['featureFlags', cleanUserId], () => axios.get(FEATURE_FLAGS(cleanUserId)), {
    staleTime: STALE_TIME,
  });

  const enabledFlags = useMemo(
    () => (isLoading || isError ? null : _keyBy(data)),
    [isLoading, isError, data]
  );

  const isFlagEnabled = useCallback(
    flagName => {
      return !!enabledFlags?.[flagName];
    },
    [enabledFlags]
  );

  return { isFlagEnabled, isLoading };
};

export default useFeatureFlags;
